import { parse } from 'cookie';

/**
 * workaround for setInterval / promise bug in jest
 * https://github.com/facebook/jest/issues/9181
 */
export const advanceAsyncTimers = async ({
  interval,
  maxTime,
}: {
  interval: number;
  maxTime: number;
}) => {
  let attemptNumber = 0;
  const maxAttempts = Math.floor(maxTime / interval);
  if (maxAttempts < 1) {
    throw new RangeError('Max attempts must not be zero');
  }

  for (attemptNumber; attemptNumber <= maxAttempts; attemptNumber++) {
    jest.advanceTimersByTime(interval);
    await Promise.resolve();
  }
};

export const isSeekTest = (): boolean => {
  // cookie check is for DataDog synthetics tests
  const cookie = parse(document.cookie);
  return window.SEEK_TEST || window.TEST_USER || cookie.SEEK_TEST === 'true';
};
